import { observer } from 'mobx-react';
import * as React from 'react';
import { GridColumn, Notice, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';

export interface InsuranceCalculatorResultProps {
  offerTitle: string;
  priceMonth: string;
  priceDay: string;
  totalPrice: string;
  gpsNeeded?: boolean;
}

@observer
class InsuranceCalculatorResult extends React.Component<InsuranceCalculatorResultProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  public render() {
    const translate = this.context.translate;
    const { offerTitle, priceMonth, priceDay, totalPrice, gpsNeeded = false } = this.props;
    return (
      <GridColumn width={['xs']}>
        <Text className="text-left">
          <p className="text-bold">{offerTitle}</p>
          <div className="text-bold">
            {translate('vehicleInsurance.price.dayAndMonth', {
              priceMonth,
              priceDay,
            })}
          </div>
          <Notice size="small">
            <div className="text-bold">
              {translate('vehicleInsurance.price.total', {
                totalPrice: totalPrice,
              })}
              <div>{gpsNeeded && translate('vehicleInsurance.price.gpsNeeded')}</div>
            </div>
          </Notice>
        </Text>
      </GridColumn>
    );
  }
}

export default InsuranceCalculatorResult;
